module.exports = __webpack_public_path__ + "img/pr-19.5b7aab15.png";